import request from '../axios/axios';
const BASE_URL = "/name";


export const generateNames = (params) => request({
    url: `${BASE_URL}/generate`,
    params: params,
    method: 'get'
});

